import {gql} from "@apollo/client";

export const CREATE_BAND = gql`
    mutation CreateBand($name: String!, $city: String!, $latitude: String!, $longitude: String!, $range: numeric!) {
      createBand(band: {city: $city, latitude: $latitude, longitude: $longitude, name: $name, range: $range}) {
        band_id
      }
    }
`;